import { Injectable } from '@angular/core';
import { TeacherService } from './teacher.service';
import { Project } from '../interfaces/project';
import { Teacher } from '../interfaces/teacher';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private db = firebase.firestore();

  constructor(private teacherService: TeacherService) {}

  /** Get current logged-in teacher */
  async getCurrentTeacher(): Promise<Teacher | null> {
    return this.teacherService.getTeacher();
  }

  /** Fetch projects visible to the current user */
  async getProjects(): Promise<Project[]> {
    const teacher = await this.getCurrentTeacher();
    const role = teacher?.role?.toLowerCase() ?? '';
    const teacherSchool = teacher?.school?.toLowerCase() ?? '';

    // Firestore query: visibility-based
    let query = this.db.collection('projects') as firebase.firestore.Query;

    // Teachers/GHS reps will see projects with visibility "Everyone" or "My School"
    query = query.where('visibility', 'in', ['Everyone', 'My School']);

    const snapshot = await query.get();
    const projects: Project[] = [];

    snapshot.forEach(doc => {
      const data = { id: doc.id, ...doc.data() } as Project;

      // If teacher or GHS rep, only show projects from their school
      if ((role === 'teacher' || role === 'ghs teacher representative') &&
        data.school?.toLowerCase() !== teacherSchool && data.isDeleted) {
        return; // skip
      }

      // Admins see deleted projects
      if (role === 'admin') {
        projects.push(data);
      }

      projects.push(data);
    });

    return projects;
  }
}
